<template>
    <span class="contenedor-meu showButton" @click="(SwResource())">
        <div><i class="fas fa-bars"></i> Menu </div>
    </span>
</template>

<script>
    import {mapState, mapGetters} from 'vuex'
    export default {
        name: 'sideBarResponsive',

        components: {
        },
        created(){

        },
        data () {
            return {

            }
        },
        computed: {
            ...mapState,
            ...mapGetters([
                'course/modules_all',
                'course/lessons_all',
                'drawer_true'
            ]),
        },
        methods:{
            SwResource: function () {
                if (this.drawer_true === false){
                    console.log('true')
                    this.$store.commit('Rdrawer', true);

                }else{
                    console.log('false')
                    this.$store.commit('Rdrawer', false);

                }
            },
        }
    }
</script>
<style scoped>
    .contenedor-meu{
        width: 100%;;
        height: 50px;

        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        color: white;
        font-size: 1.5rem;
        font-weight: 600;
        cursor: pointer;
    }
    .showButton{
        display: none;

    }
    @media (min-width: 1281px) {

    }

    @media (min-width: 1025px) and (max-width: 1280px) {

    }


    @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {

    }

    @media (min-width: 181px) and (max-width: 1023px) {
        .showButton{
            display: flex;
            background-color: orangered;
            margin-left: 5px;
        }
        .showButton:hover{

            background-color: #ff771c;

        }
        .marginLeft{
            padding-left: 20px !important;

        }
        .show{
            display: none;
        }
        .contenedor{
            display: grid;
            grid-template-columns: 100%;
            grid-template-rows: 10px 1fr 1fr 1fr;
            margin-top:50px;

        }
    }
</style>